<template>
  <LayoutBasic :showLinksMenu="false" width="380" >
    <template v-slot:breadcrumbs>
      <nav class="nexus-mini-nav pa-4 pb-0">
        <span class="grey--text text-caption font-weight-bold uppercase">{{ tipoGestion }}</span>
        <v-icon x-small color="grey" class="mx-2">mdi-chevron-right</v-icon>
        <span class="white--text text-caption font-weight-bold">HISTORIAL</span>
      </nav>
    </template>

    <template v-slot:navigation-title>
      <div class="px-1">Consultar {{ tipoGestion }}</div>
    </template>

    <template v-slot:navigation-content>
      <div class="nexus-filters-container px-4 py-2">
        
        <section class="filter-group mb-4">
          <label class="nexus-label-sm">Tipo de Movimiento</label>
          <v-btn-toggle
            v-model="esVenta"
            mandatory
            borderless
            class="mt-2 nexus-toggle-group"
            @change="alCambiarTipo"
          >
            <v-btn :value="true" active-class="bg-primary-nexus" small>Ventas</v-btn>
            <v-btn :value="false" active-class="bg-primary-nexus" small>Compras</v-btn>
          </v-btn-toggle>
        </section>

        <section class="filter-group mb-6">
          <label class="nexus-label-sm">Documentos</label>
          <v-select
            v-model="documentosSeleccionados"
            :items="opcionesDocumentos"
            multiple
            chips
            deletable-chips
            dense
            solo
            flat
            background-color="rgba(255,255,255,0.05)"
            class="custom-nexus-input mt-2"
            placeholder="Todos los documentos"
          ></v-select>
        </section>

        <section class="filter-group mb-6">
          <label class="nexus-label-sm">Búsqueda rápida</label>
          <VentasBuscador
            class="custom-nexus-input mt-2"
            :numeroComprobante="numeroComprobante"
            @update:numeroComprobante="setNroComprobante"
            :placeholder="`Nro. de ${tipoGestionSingular}`"
          />
          
          <cliente-buscador
            class="custom-nexus-input mt-3"
            :label="esVenta ? 'Buscar Cliente' : 'Buscar Proveedor'"
            @set-cliente="setEntidad"
            @remove-cliente="removeEntidad"
          />
        </section>

        <section class="filter-group mb-8">
          <label class="nexus-label-sm">Rango de tiempo</label>
          <v-card flat color="rgba(255,255,255,0.03)" class="pa-3 mt-2 border-nexus">
            <v-row dense>
              <v-col cols="6">
                <v-menu v-model="menuInicio" :close-on-content-click="false" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="date-picker-trigger" v-bind="attrs" v-on="on">
                      <span class="d-block grey--text text-overline">Desde</span>
                      <span class="white--text body-2 font-weight-bold">{{ fechaInicio }}</span>
                    </div>
                  </template>
                  <v-date-picker color="blue accent-2" v-model="fechaInicio" no-title locale="es" @input="menuInicio = false" />
                </v-menu>
              </v-col>
              <v-col cols="6" class="border-left-nexus">
                <v-menu v-model="menuFin" :close-on-content-click="false" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="date-picker-trigger pl-3" v-bind="attrs" v-on="on">
                      <span class="d-block grey--text text-overline">Hasta</span>
                      <span class="white--text body-2 font-weight-bold">{{ fechaFin }}</span>
                    </div>
                  </template>
                  <v-date-picker color="blue accent-2" v-model="fechaFin" no-title locale="es" @input="menuFin = false" />
                </v-menu>
              </v-col>
            </v-row>
          </v-card>
        </section>

        <v-btn 
          x-large 
          color="#4dabf7" 
          block 
          depressed 
          class="white--text font-weight-black nexus-main-btn"
          @click="consultarComprobantes"
          :loading="loading"
        >
          <v-icon left>mdi-magnify</v-icon>
          APLICAR FILTROS
        </v-btn>
      </div>
    </template>

    <template v-slot:vista-previa>
      <router-view
        :items="resultados"
        :paginacion="paginacion"
        :loading="loading"
        :esVenta="esVenta"
        @set-page="setPage"
      />
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from "@/layouts/LayoutBasic.vue";
import VentasBuscador from "@/components/venta/consultar/VentasBuscador.vue";
import ClienteBuscador from "@/components/cliente/cliente.buscador.vue";

export default {
  name: "ComprobantesConsultar",
  components: { LayoutBasic, VentasBuscador, ClienteBuscador },
  
  data() {
    return {
      resultados: [],
      loading: false,
      esVenta: true, // Switch principal
      documentosSeleccionados: ['FC', 'NV'],
      opcionesDocumentos: [
        { text: 'Factura', value: 'FC' },
        { text: 'Nota de Venta', value: 'NV' },
        { text: 'Remito', value: 'RM' },
        { text: 'Presupuesto', value: 'PR' }
      ],
      paginacion: { page: 1, cantidad: 0, rowsPerPage: 10 },
      menuInicio: false,
      menuFin: false,
      fechaInicio: new Date().toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      entidad: null, // Puede ser Cliente o Proveedor
      numeroComprobante: "",
    };
  },

  computed: {
    tipoGestion() {
      return this.esVenta ? 'VENTAS' : 'COMPRAS';
    },
    tipoGestionSingular() {
      return this.esVenta ? 'Venta' : 'Compra';
    }
  },

  methods: {
    alCambiarTipo() {
      this.resultados = [];
      this.entidad = null;
      this.consultarComprobantes();
    },
    setNroComprobante(val) { this.numeroComprobante = val; },
    setEntidad(data) { this.entidad = data; this.consultarComprobantes(); },
    removeEntidad() { this.entidad = null; },
    
    consultarComprobantes() {
      this.paginacion.page = 1;
      this.fetchComprobantes();
    },

    fetchComprobantes() {
      this.loading = true;
      
      // Unificamos la lógica de documentos: "FC|NV|RM"
      const docsQuery = this.documentosSeleccionados.join('|');
      
      let url = `/comprobantes/comprobantes?esVenta=${this.esVenta}&doc=${docsQuery}&page=${this.paginacion.page}&page_size=${this.paginacion.rowsPerPage}&fecha_contable_after=${this.fechaInicio}&fecha_contable_before=${this.fechaFin}`;

      if (this.entidad) {
        // Asumiendo que el backend usa la misma key o podrías condicionarla
        const keyEntidad = this.esVenta ? 'cliente' : 'proveedor';
        url += `&${keyEntidad}=${this.entidad.id}`;
      }

      if (this.numeroComprobante) {
        url += `&numero=${this.numeroComprobante}`;
      }

      this.axios.get(url)
        .then((response) => {
          this.resultados = response.data.results;
          this.paginacion.cantidad = response.data.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setPage(page) {
      this.paginacion.page = page;
      this.fetchComprobantes();
    }
  },

  created() {
    this.fetchComprobantes();
  }
};
</script>

<style lang="scss" scoped>
/* Mantengo tus estilos y añado ajustes para el toggle */
.nexus-label-sm {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255,255,255,0.4);
  font-weight: 800;
}

.nexus-toggle-group {
  width: 100%;
  background: rgba(255,255,255,0.05) !important;
  border-radius: 8px;
  padding: 4px;
  .v-btn {
    width: 50%;
    border: none !important;
    border-radius: 6px !important;
    color: rgba(255,255,255,0.6);
  }
}

.bg-primary-nexus {
  background-color: #4dabf7 !important;
  color: white !important;
}

.border-nexus {
  border: 1px solid rgba(255,255,255,0.08) !important;
  border-radius: 8px;
}

.border-left-nexus {
  border-left: 1px solid rgba(255,255,255,0.08);
}

.date-picker-trigger {
  cursor: pointer;
  &:hover span.white--text { color: #4dabf7 !important; }
}

.nexus-main-btn {
  border-radius: 12px;
  letter-spacing: 0.5px;
}

::v-deep .custom-nexus-input {
  .v-input__slot {
    background: rgba(255,255,255,0.05) !important;
    border: 1px solid rgba(255,255,255,0.1) !important;
    box-shadow: none !important;
  }
}
</style>